import React, { useState, useEffect } from 'react';
import { recordHoldersAPI } from '../services/api';
import RecordCard from './RecordCard';

const RecordsGallery = () => {
  const [recordHolders, setRecordHolders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const holdersData = await recordHoldersAPI.getAll();
        setRecordHolders(holdersData);
        setError(null);
      } catch (err) {
        console.error('Error fetching gallery data:', err);
        setError('Failed to load gallery data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-red-700"></div>
            <p className="mt-4 text-gray-600">Loading gallery...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <div className="text-center text-red-600">
            <p>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 py-16">
      {/* Record Holders Section */}
      <section className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
          Record Holders
        </h2>
        
        {recordHolders.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">No record holders to display yet.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {recordHolders.map((holder) => (
              <RecordCard key={holder.id} holder={holder} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default RecordsGallery;
